// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductFacetList":"ef_a bii_g","ProductFacetList__pill":"ef_b"};